//#region src/bite_log_elavon_event.ts
var BiteLogElavonEvent = /* @__PURE__ */ function(BiteLogElavonEvent) {
	BiteLogElavonEvent[BiteLogElavonEvent["None"] = 0] = "None";
	BiteLogElavonEvent[BiteLogElavonEvent["TerminalDisconnected"] = 1] = "TerminalDisconnected";
	BiteLogElavonEvent[BiteLogElavonEvent["UpdateIdleTextError"] = 2] = "UpdateIdleTextError";
	BiteLogElavonEvent[BiteLogElavonEvent["SaleTransaction"] = 3] = "SaleTransaction";
	BiteLogElavonEvent[BiteLogElavonEvent["SaleTransactionError"] = 4] = "SaleTransactionError";
	BiteLogElavonEvent[BiteLogElavonEvent["TerminalConnected"] = 5] = "TerminalConnected";
	BiteLogElavonEvent[BiteLogElavonEvent["NoResponseReceived"] = 6] = "NoResponseReceived";
	BiteLogElavonEvent[BiteLogElavonEvent["InquiryTransaction"] = 7] = "InquiryTransaction";
	BiteLogElavonEvent[BiteLogElavonEvent["InquiryTransactionError"] = 8] = "InquiryTransactionError";
	BiteLogElavonEvent[BiteLogElavonEvent["CancelTransaction"] = 9] = "CancelTransaction";
	BiteLogElavonEvent[BiteLogElavonEvent["CancelTransactionError"] = 10] = "CancelTransactionError";
	BiteLogElavonEvent[BiteLogElavonEvent["GetOrSaveReferenceSequenceFailed"] = 11] = "GetOrSaveReferenceSequenceFailed";
	BiteLogElavonEvent[BiteLogElavonEvent["OptConnectFailure"] = 12] = "OptConnectFailure";
	return BiteLogElavonEvent;
}(BiteLogElavonEvent || {});
//#endregion
export { BiteLogElavonEvent };

//# sourceMappingURL=bite_log_elavon_event.js.map